import ItemBoxesConnected from '../../components/molecules/item_boxes/ItemBoxesConnected.vue'
import SmallLoading from '../../components/atoms/loadings/SmallLoading.vue'
import axios from 'axios'
import ImgLazy from '../../components/atoms/images/ImgLazy.vue'

export default {
  components: {
    ItemBoxesConnected,
    SmallLoading,
    ImgLazy
  },
  data() {
    return {
      brandId: '',
      brandItems: [],
      isLoading: true,
      showableBrandDescription: false
    }
  },
  mounted() {
    this.brandId = location.pathname.split('/brands/')[1]
    this.getBrandItems()
  },
  methods: {
    async getBrandItems() {
      try {
        const res = await axios.get(
          `/api/v1/pickup/brands/${this.brandId}/items`
        )
        this.brandItems = res.data.data
          .map(item => item.attributes)
          .map(item => {
            return {
              id: item.id,
              linkUrl: `/items/${item.id}`,
              imageUrl: item.item_box_image_url,
              brandName: item.brand_name,
              itemName: item.name,
              itemPrice: item.min_price.toLocaleString(),
              isIncludingTax: item.is_including_tax,
              hasMultipleItemSkus: item.item_sku_count > 1,
              soldOut: item.sold_out
            }
          })
      } catch (error) {
        this.errorMessage =
          error.response.data && error.response.data.message
            ? error.response.data.message
            : 'システムエラーが発生しました。しばらく経ってから再度アクセスしてください'
      }
      this.isLoading = false
    },
    toggleBrandDescription() {
      this.showableBrandDescription = !this.showableBrandDescription
    },
    beforeEnter(el) {
      el.style.height = '0'
    },
    enter(el) {
      el.style.height = el.scrollHeight + 'px'
    },
    beforeLeave(el) {
      el.style.height = el.scrollHeight + 'px'
    },
    leave(el) {
      el.style.height = '0'
    },
    onClickBackToTop() {
      window.scrollTo({ top, behavior: 'smooth' })
    }
  }
}
